import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

function Navbar({ loggedIn, logout, ...props }) {
	return (
		<div className="navbar-container">
			<div className="navbar-left-container">
				<div className="navbar-title">CARMANDEE-ADMIN</div>
			</div>
			<div className="navbar-right-container">{loggedIn && <div onClick={logout}>Logout</div>}</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	user: state.session.user,
	loggedIn: state.session.loggedIn,
});

const mapDispatchToProps = (dispatch) => ({
	logout: () => dispatch(Actions.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Navbar));
